import { ReactElement } from 'react'

import { WEEKDAYS } from '../constants'
import { translate } from './translations/translator'

export const generateWeekdayOptions = (): ReactElement[] => [
    ...WEEKDAYS.map((weekDay, index) => (
        <option
            key={`index-${index + 1}`}
            value={index + 1}
        >
            {translate(`common.weekDays.${weekDay}`)}
        </option>
    )),
]

export const generateSelectOptions = (array: (string | number)[], defaultValue?: string | number): ReactElement[] => array
    .map((type: string | number) => {
        const label = typeof type === 'string'
            ? translate(`common.${type}`)
            : type

        return (
            <option
                key={type}
                value={type}
                selected={type === defaultValue}
            >
                {label}
            </option>
        )
    })
